import { corptaxCustomLightTheme } from '@cscglobal-tbs/react-components-core';
import { Theme } from '@fluentui/react-components';
import { ICustomPalette } from './ICustomPalette';

export { fluentCustomStyleHooks } from './fluentCustomStyleHooks';

// TEMPORARY - this change was made in react-components-core theme,
// but there's also a syncfusion upgrade in a related package version,
// and we're not ready to take that upgrade
corptaxCustomLightTheme.colorNeutralForegroundDisabled = '#B4B6B7';
corptaxCustomLightTheme.fontFamilyBase =
    "'Segoe UI', 'Segoe UI Web (West European)', -apple-system, BlinkMacSystemFont, Roboto, 'Helvetica Neue', sans-serif";

/**
 * App color palette (static). Formerly nested under Fluent v8 ThemeProvider
 * `themeSettings`; now imported directly.
 */
export const customPalette: ICustomPalette = {
    statusLightOrange: '#FFCBA6',
    statusMidOrange: '#F5C3A7',
    statusDarkOrange: '#EBBBA0',
    statusLightGreen: '#DFF6DD',
    statusMidGreen: '#D4EBD2',
    statusDarkGreen: '#CBE0C9',
    statusLightBlue: '#E5F0FF',
    statusMidBlue: '#DCE6F5',
    statusDarkBlue: '#D3DCEB',
    statusLightCyan: '#CCF0EE',
    statusMidCyan: '#99E0DD',
    statusDarkCyan: '#69D6D0',
    statusCoolLightGrey: '#EDEBE9',
    statusCoolMidGrey: '#F5F5F5',
    statusCoolDarkGrey: '#EAEBEB',
    themePrimary: '#003b5c', //why do we need to duplicate theme colors here?
    themeSecondary: '#2b88d8',
    themeTertiary: '#71afe5',
    themeLighter: '#f5f8ff',
    themeLighterAlt: '#eff6fc',
    themeLight: '#D9EAFD',
    themeDark: '#313131',
    themeDarker: '#05183E',
    themeDarkAlt: '#747474',
    neutralPrimary: '#333',
    neutralPrimaryAlt: '#4b4b4b',
    neutralSecondary: '#2C2E30',
    neutralSecondaryAlt: '#E7E8E9',
    neutralTertiaryAlt: '#545855',
    neutralTertiary: '#c2c2c2',
    neutralLighter: '#F9F9FC',
    neutralLighterAlt: '#EFF7FF',
    neutralQuaternaryAlt: '#dadada',
    neutralLightGrey: '#d2d2d2',
    neutralGrey: '#616161',
    neutralDark: '#585756',
    neutralDarker: '#2C2C2E',
    lightGreen: '#D1FAE5',
    darkGreen: '#107C10',
    whiteTranslucent40: 'rgba(255,255,255,.4)',
    blueLight: '#0036fa',
    blueMid: '#174DC2',
    blueDark: '#323130', //this is gray not blue...
    greenDark: '#605E5C', //this is gray not green....
    orangeLight: '#FFD9C2',
    orangeLighter: '#FEE7CC',
    red: '#D00024',
    yellowDark: '#F3C319',
    redLighter: '#FEE2E2',
    disabledGrey: '#F5F5F5',
    disabledGreyBorder: '#C7C7C7',
    cementGrey: '#97999B',
    blue075A92: '#075A92',
    greyD1D3D4: '#D1D3D4',
    greyD3D2D1: '#D3D2D1',
    grey616567: '#616567',
    blueDFF1FD: '#DFF1FD',
    blueEBF6FD: '#EBF6FD',
    grey222222: '#222222',
    greyC3C5C6: '#C3C5C6',
    grey939393: '#939393',
    goldenrod: '#DAA520',
    lightBlue: '#A8DEFD',
    lineGrey: '#DFDFDFDF',
    blueCerulean: '#0F6CBD',
    lightCeruleanBlue: '#B4D6FA',
    warningBackground: '#FFF8E8',
    errorBackground: '#F5879133',
    blueC7DCE5: '#C7DCE5',
    blueGreyNeutral: '#8DB9CA',
    blueGreyNeutralTint2: '#EDF5F7',
};

/*For now, this simply serves as a way to temporarily invert certain design tokens from the light theme on the Panel component. 
The base Fluent theme does not provide a background color for a Panel/Drawer header, but we provide one for Drilldown and
Calculation Options

While we could use the palette directly, using the design tokens makes more sense semantically*/
export const cometDarkTheme: Theme = {
    ...corptaxCustomLightTheme,
    colorNeutralForeground1: '#FFFFFF',
    colorNeutralForeground1Hover: '#FFFFFF',
    colorNeutralStroke1Hover: '#7C7F81',
    colorNeutralStroke1Pressed: '#6F7274',
    colorNeutralStrokeDisabled: '#B4B6B7',
    colorNeutralBackground2Hover: '#F5F5F5',
    colorNeutralBackground2Pressed: '#E2E3E4',
};
